import { render, staticRenderFns } from "./TaxFormDialog.vue?vue&type=template&id=38a565ca&"
import script from "./TaxFormDialog.vue?vue&type=script&lang=ts&"
export * from "./TaxFormDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports